import React, { useState } from 'react'
import { HiDotsVertical } from 'react-icons/hi'
import { FaBoxOpen, FaShoppingCart } from 'react-icons/fa'
import { GiFactory } from 'react-icons/gi'
import { BsFileText } from 'react-icons/bs'
import FloatingMenu from '../../components/Display/FloatingMenu'
import { IWarehouse } from 'safe'
import ModalConfirm from '../../components/Display/ModalConfirm'
import { getLocationExistenceValue } from '../../utils/utils'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import { BiStore } from 'react-icons/bi'

const LocationCard: React.FC<LocationCardProps> = ({
  location,
  setModal,
  setEditingLocation,
  onDelete,
  enableFloating = true,
  onClickCard,
}) => {
  const [visibleMenu, setVisibleMenu] = useState<boolean>(false)
  const [modalDescription, setModalDescription] = useState<boolean>(false)
  const [displayConfirm, setDisplayConfirm] = useState<boolean>(false)

  // let existencesValues = {
  //   0: (value) => (value === '0' ? 'Sin existencia' : `${value} Existencia`),
  //   1: (value) => `${value} Existencias`,
  // }

  const toggle = () => {
    setVisibleMenu((state) => !state)
  }

  const edit = () => {
    toggle()
    setModal(true)
    setEditingLocation(location)
  }

  const _delete = () => {
    onDelete && onDelete(location)
    toggle()
  }

  const getLocationType = (location_type: string): string => {
    if (location_type === 'PRODUCTION') return 'PRODUCCIÓN'
    if (location_type === 'SALE FLOOR') return 'PISO DE VENTA'
    if (location_type === 'WAREHOUSE') return 'ALMACÉN'
    return 'valor malo'
  }

  let locationDetails = ''
  locationDetails += `Nomber: ${location.name}\n`
  locationDetails += `Descripción: ${location.description}\n`
  locationDetails += `Tipo de Almacén: ${getLocationType(
    // @ts-ignore
    location.warehouse_type
  )}\n`

  const clickCard = (): void => {
    if (onClickCard) {
      onClickCard(location)
    } else {
      setModalDescription(true)
    }
  }

  return (
    <>
      <ModalViewWithTabs
        display={modalDescription}
        onClose={() => {
          setModalDescription(false)
        }}
        dataWithTabs={[{ title: 'Almacén', data: locationDetails }]}
      />

      <div className="2xl:w-96 w-80 shadow-lg rounded-lg p-4 text-xl flex justify-between relative dark:bg-black m-auto">
        <div className="w-72 cursor-pointer" onClick={() => clickCard()}>
          <div className="flex mb-3">
            <div className="mr-4 text-primary-600">
              <BiStore className='dark:text-white text-dark' />
              {/* {location.warehouse_type === 'SALE FLOOR' && (
                <FaShoppingCart
                  size="1.2rem"
                  className="dark:text-primaryGreen-300 text-primaryGreen-500"
                />
              )}
              {location.warehouse_type === 'WAREHOUSE' && (
                <FaBoxOpen size="1.2rem" />
              )}
              {location.warehouse_type === 'PRODUCTION' && (
                <GiFactory
                  size="1.2rem"
                  className="text-primaryOrange-dark dark:text-primaryOrange"
                />
              )} */}
            </div>
            <div className="truncate font-medium text-sm dark:text-white text-dark">
              {location.name}
            </div>
          </div>
          <div className="h-8 flex items-center">
            <div className="flex items-center truncate text-primary-600 font-medium">
              {/* <div className="mr-4"> */}
                {/* <BsFileText
                  size="0.9rem"
                  className={`${
                    location.warehouse_type === 'SALE FLOOR' &&
                    'dark:text-primaryGreen-300 text-primaryGreen-500'
                  } ${
                    location.warehouse_type === 'PRODUCTION' &&
                    'text-primaryOrange-dark dark:text-primaryOrange'
                  }`}
                /> */}
              {/* </div> */}
              <div className="truncate text-sm max-h-10 dark:text-white">
                {location.description}
              </div>
            </div>
          </div>

          <div
            className={`mt-1 flex text-sm flex-row justify-between ${
              location.warehouseType === 'PRODUCTION' &&
              'text-primaryOrange-dark dark:text-primaryOrange'
            } ${
              location.warehouseType === 'SALE FLOOR' &&
              'text-purple-500'
            } ${location.warehouseType === 'WAREHOUSE' && 'text-primary-300'}`}
            style={{ fontSize: '11px', fontWeight: 600 }}
          >
            <div>
              {getLocationExistenceValue()[
                Number(+location.numberOfExistences > 1)
              ](location.numberOfExistences)}
            </div>
            <div>{getLocationType(location.warehouseType)}</div>
          </div>
        </div>

        {location.warehouseType !== 'SALE FLOOR' && (
          <FloatingMenu
            onClose={() => setVisibleMenu(false)}
            visible={visibleMenu}
            options={
              
                { onEdit: edit, onDelete: () => setDisplayConfirm(true) }
            }
          >
            <HiDotsVertical
              className="cursor-pointer text-gray-400"
              onClick={toggle}
            />
          </FloatingMenu>
        )}
      </div>
      <ModalConfirm
        title={'¿Está seguro que desea eliminar el almacén?'}
        displayConfirmModal={displayConfirm}
        onConfirm={() => _delete()}
        onCancel={() => setDisplayConfirm(false)}
      ></ModalConfirm>
    </>
  )
}

export default LocationCard

interface LocationCardProps {
  location: IWarehouse
  setModal: Function
  setEditingLocation: Function
  onDelete?: Function
  enableFloating?: boolean
  onClickCard?(warehouse: IWarehouse): void
}
